<emm-management-layout>
    <emm-item-id-mappings-form *ngIf="true" #form layout-center-content
        [isSuperAdmin]="isSuperAdmin"
        [isAdmin]="isAdmin"
        (search)="itemIdMappingsForm.doSearch()"
        (upsert)="itemIdMappingsForm.doSubmit()"
                            ></emm-item-id-mappings-form >
</emm-management-layout>
